import View from './views/View'

const route = {
    exact: true,
    purePath: '/',
    path: '/:lang',
    component: View
}

export default route